import { Outlet, Link } from "react-router-dom";
import { ClubLogo } from "@/components/brand/ClubLogo";
import { mockAssets } from "@/mocks/assets";

export function AuthLayout() {
  return (
    <div className="grid min-h-dvh grid-cols-1 lg:grid-cols-2">
      <div className="relative hidden overflow-hidden bg-navy-deep text-white lg:block">
        <img
          src={mockAssets.hero[0]}
          alt=""
          className="absolute inset-0 size-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-navy-deep via-navy-deep/70 to-navy" />
        <div className="relative flex h-full flex-col justify-between p-10">
          <Link to="/" className="inline-flex items-center gap-3">
            <ClubLogo variant="icon" className="h-14 w-14" priority />
            <span className="text-display text-lg font-bold uppercase tracking-wide">
              Soweto Super United FC
            </span>
          </Link>
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-gold">
              Club Portal
            </p>
            <h1 className="mt-3 text-display text-5xl uppercase leading-none">
              Rise. Play.
              <br />
              <span className="text-gold">Belong.</span>
            </h1>
            <p className="mt-4 max-w-md text-silver-light">
              Portal access for staff, coaches, players and match operations. All data is scoped by
              role.
            </p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center bg-off-white p-6">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
